import React, { useEffect, useState } from 'react';
import { BetImageUploader } from '../BetImageUploader/BetImageUploader';
import { Mediafile } from '../interfaces/Media';
import { ConnectedPreview } from '../Preview/Preview';
import styles from './Steps.module.scss';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';
import defaultTipsterImage from '../../../assets/icons/ic_tipster_default.svg';
import { SimpleTip } from '../interfaces/tip/SimpleTip';
import { CombinedTip } from '../interfaces/tip/CombinedTip';
import { Credentials } from '../../../types/Login';
import { OddsFormat } from '../interfaces/utils';
import { Tip } from '../interfaces/tip/Tip';
import { valueof } from '../interfaces/tip/MatchForecast';
import axios from 'axios';
import { getApiAuthorization } from '../../../api/utils';

interface StepFourProps {
  hooks: {
    tip: SimpleTip | CombinedTip;
    handleTipValue: (key: keyof Tip, value: valueof<Tip>) => void;
  };
  showValidations: boolean;
  user: Credentials | null;
  oddsFormat: OddsFormat;
}

interface OwnedSpace {
  id: string;
  name: string;
  alias: string;
  image_url: string;
  is_challenge: boolean;
}

interface OwnedSpacesResponse {
  owned_spaces: OwnedSpace[];
}

export const StepFour: React.FC<StepFourProps> = ({
  hooks: { tip, handleTipValue },
  showValidations,
  user,
  oddsFormat,
}) => {
  const { t } = useTranslation();
  const isValid = tip.validations.step4.betImage.isValid;
  const isChallenge = window.location.href.includes('challenge');
  const [tipsterName, setTipsterName] = useState<string | null>(null);
  const [tipsterAvatar, setTipsterAvatar] = useState<string | null>(null);
  const token = getApiAuthorization();

  useEffect(() => {
    const fetchTipsterInfo = async () => {
      const urlParts = window.location.href.split('/');
      const lastPart = urlParts[urlParts.length - 1];

      try {
        const response: any = await axios.get<OwnedSpacesResponse>(
          'v1/spaces/owned',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const ownedSpace = response.owned_spaces.find(
          (space: OwnedSpace) => space.id === lastPart,
        );

        if (ownedSpace) {
          setTipsterName(ownedSpace.name);
          setTipsterAvatar(ownedSpace.image_url);
        }
      } catch (error) {
        console.error('Error fetching owned channels:', error);
      }
    };

    if (isChallenge) {
      fetchTipsterInfo();
    }
  }, [isChallenge, token]);

  return (
    <div className={styles.StepsContent}>
      <span className={styles.header}>
        {tr(t, 'image-of-the-bet').toUpperCase()}
      </span>
      <span className={styles.subHeader}>{tr(t, 'image-of-the-bet_info')}</span>
      <BetImageUploader
        onSelect={(betImage: Mediafile | null) =>
          handleTipValue('betImage', betImage)
        }
        value={tip.betImage}
        isValid={showValidations ? isValid : true}
      />
      {user && (
        <div className={styles.tipsterAvatarWrapper}>
          <img
            src={isChallenge ? tipsterAvatar || defaultTipsterImage : user.user.avatar_url || defaultTipsterImage}
            className={styles.avatar}
            alt="user profile pic"
          />
          <div>
            <p>{isChallenge ? tipsterName : user.user.username}</p>
          </div>
        </div>
      )}
      <div className={isChallenge ? styles.challengeBetslip : ''}>
        <ConnectedPreview tip={tip} oddsFormat={oddsFormat} isChallenge={isChallenge} />
      </div>
    </div>
  );
};